module.exports = __webpack_public_path__ + "img/analyst-hours.b63e74a6.png";